<template>
  <footer class="edu-footer-area">
    <div class="container">
      <div class="footer-top-area ptb-100">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-footer-widget">
              <router-link to="/" class="logo">
                <img src="../../assets/img/logo/cvision-white.svg" alt="image" />
              </router-link>
              <p>
                En iyi online eğitimi sunuyoruz.
                Öğrenmeyi her zaman, her yerde erişilebilir kılıyoruz.
                Bize katılın!
              </p>
              <ul class="social-links">
                <li>
                  <a href="https://www.facebook.com/" target="_blank">
                    <i class="bx bxl-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/" target="_blank">
                    <i class="bx bxl-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/" target="_blank">
                    <i class="bx bxl-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/" target="_blank">
                    <i class="bx bxl-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="single-footer-widget pl-5">
              <h3>Links</h3>
              <ul class="links-list">
                <li><router-link to="/">Anasayfa</router-link></li>
                <li>
                  <router-link to="/about">Hakkımızda</router-link>
                </li>
                <li>
                  <router-link to="/courses">Kurslar</router-link>
                </li>
                <li>
                  <router-link to="/contact">İletişim</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="pr-line"></div>
      <div class="footer-bottom-area">
        <p>
          © Copyright {{ currentYear }} |
          <a href="#" target="_blank">Cvision </a> | Tüm Hakları Saklıdır
        </p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "MainFooter",
  setup() {
    const currentYear = ref(new Date().getFullYear());

    return {
      currentYear,
    };
  },
});
</script>